// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btndel[data-v-2764830b]{position:absolute;z-index:1;width:20px !important;height:20px !important;left:46px;top:-4px}.pictrue[data-v-2764830b]{width:60px;height:60px;border:1px dotted rgba(0,0,0,.1);margin-right:10px;position:relative;cursor:pointer}.pictrue img[data-v-2764830b]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
